import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../interfaces/user.model';
import { AppSettings } from '../app.settings';
import { Observable } from 'rxjs/internal/Observable';
import { CustomResponse } from '../interfaces/custom-response.model';

@Injectable({ providedIn: 'root' })

export class UserService {
    private apiEndpoint: string = "";

    constructor(private http: HttpClient) {
        this.apiEndpoint = AppSettings.settings.apiServer.backend;
    }

    getAll(): Observable<CustomResponse>{
        return this.http.get<CustomResponse>(`${this.apiEndpoint}/users`);
    }

    /* Update default template */
    updateTheme(id: string, themename: string): Observable<any> {
        let url = `${this.apiEndpoint}/updatetheme/${id}`;

        return this.http.post(url, { themename: themename });
    }

    updateStandardNiederlassung(niederlassung_id: number, userid: string): Observable<CustomResponse> {
        let url = `${this.apiEndpoint}/users/${userid}/updatestandort`;

        return this.http.post<CustomResponse>(url, { "niederlassung_id": niederlassung_id });
    }

    updateUser(data: any): Observable<CustomResponse> {

        let url = `${this.apiEndpoint}/users`;

        return this.http.put<CustomResponse>(url, data);
    };

    addUser(data: any) : Observable<CustomResponse> {
        let url = `${this.apiEndpoint}/users`;
        return this.http.post<CustomResponse>(url, data);
    };

    deleteUser(id: string) : Observable<CustomResponse> {
        let url = `${this.apiEndpoint}/users/${id}`;
        return this.http.delete<CustomResponse>(url);
    }

    changePassword(usesrid: string, data: any) : Observable<CustomResponse> {
        let url = `${this.apiEndpoint}/users/${usesrid}/changepassword`;

        return this.http.post<CustomResponse>(url, data);
    }

    getUser(userid: string) {
        let url = `${this.apiEndpoint}/users/${userid}`;

        return this.http.get(url);
    }

}